import type { StreamingEvent } from '../../types/chat.types';
import type {
  ArtifactNode,
  ContentProcessorState,
} from '../contentProcessor.types';

export function handleArtifactEvent(
  state: ContentProcessorState,
  event: StreamingEvent<'artifact'>,
): ContentProcessorState {
  const artifactNode: ArtifactNode = {
    type: 'artifact',
    files: event.data.files,
    title: event.data.title,
  };

  return {
    ...state,
    nodes: [...state.nodes, artifactNode],
    chunks: {
      ...state.chunks,
      // Clear pending tool-progress chunks now that real content is being
      // emitted — mirrors the other content-emitting handlers (text/image/
      // tool-usage/ref). Without this, `chunks.progress.length > 0` keeps
      // `AssistantMessage` from forwarding `isStreaming` to the artifact
      // block, which suppresses the auto-open-on-stream drawer.
      progress: [],
      artifact: [...state.chunks.artifact, event.data],
    },
  };
}
